/** Pure username normalisation and validation. Safe to import anywhere. */

const USERNAME_PATTERN = /^[a-z0-9][a-z0-9._-]{1,62}$/;

export const USERNAME_MAX_LENGTH = 63;

/**
 * Lowercases and trims a submitted username. Returns null when the result is
 * not a syntactically valid username, so callers cannot accidentally build a
 * Firestore document path out of arbitrary input.
 */
/**
 * The longest string worth normalising.
 *
 * `normalize('NFKC')` is linear but not free, and a few characters expand under
 * it — `U+FDFA` becomes eighteen — so it is work an unauthenticated caller can
 * ask for by the megabyte before anything else in the request has been looked
 * at. Nothing that composes down to sixty-three ASCII characters starts anywhere
 * near this long, so the bound costs a real sign-in nothing.
 */
const RAW_MAX_LENGTH = USERNAME_MAX_LENGTH * 4;

export function normalizeUsername(raw: unknown): string | null {
  if (typeof raw !== 'string' || raw.length > RAW_MAX_LENGTH) {
    return null;
  }

  const normalized = raw.normalize('NFKC').trim().toLowerCase();
  if (!USERNAME_PATTERN.test(normalized)) {
    return null;
  }

  return normalized;
}
